var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookmono = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brand=facebook, monochrome=True"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7473 6.0625H14.4626C13.7323 6.0625 13.1848 6.36175 13.1848 7.11819V8.4375H16.7473L16.4647 12H13.1848V21.5H9.62231V12H7.24731V8.4375H9.62231V6.15394C9.62231 3.75281 10.8858 2.5 13.7323 2.5H16.7473V6.0625Z"
  }))));
};
export default SvgFacebookmono;